var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AfterViewInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import * as calcite from 'calcite-web/es6';
import { Subject } from 'rxjs';
import { environmentOm } from '../../environment-om';
import { IdentifyToggleComponent } from '../identify-toggle/identify-toggle.component';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { ReportHelper } from '../reports/report-helper';
import { ReportLauncher } from '../reports/report-launcher';
export class HomeComponent {
    constructor(elementRef, reportHelper, reportLauncher, changeDectRef) {
        this.reportHelper = reportHelper;
        this.reportLauncher = reportLauncher;
        this.changeDectRef = changeDectRef;
        this.showOverview = false;
        this.openVL = new Subject();
        this.openSV = new Subject();
        this.openShareLayer = new Subject();
        this.maxHeight = 768;
        this.sideOpen = true;
        this.dataTableMinimized = false;
        this.dataTableLayerUniqueId = null;
        this.dataTableArr = [];
        this.extentCenterPositionLong = -77.6362661695295;
        this.extentCenterPositionLat = 40.92039887644528;
        this.levelMatchingFeaturesFound = 3;
        this.levelNoMatchingFeatures = 4;
        this.levelError = 5;
        this.basemapList = 'terrain,streets-vector,satellite,topo-vector,national-geographic,gray-vector,osm';
        this.defaultBasemap = {
            tileUrl: environmentOm.basemapURL + '/rest/services/basemaps/penndotbasemap/MapServer/tile',
            thumbnailTile: '/7/48/36',
            tileTemplate: '/{level}/{row}/{col}',
            title: 'PennDOT'
        };
        this.basemapConfigs = [
            {
                tileUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/Elevation/World_Hillshade/MapServer/tile',
                thumbnailTile: '/15/12358/9365',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'Elevation'
            },
            this.defaultBasemap,
            {
                tileUrl: 'https://services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/tile',
                thumbnailTile: '/7/48/36',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'Topographic DRG'
            },
            {
                tileUrl: 'https://gis.penndot.pa.gov/img/rest/services/imagery/PEMA_2018/ImageServer/tile',
                thumbnailTile: '/13/3093/2346',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'PEMA'
            },
            {
                tileUrl: 'https://naip.maptiles.arcgis.com/arcgis/rest/services/NAIP/MapServer/tile',
                thumbnailTile: '/14/6188/4697',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'NAIP'
            },
            {
                portalItemId: '28f49811a6974659988fd279de5ce39f',
                tileUrl: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile',
                thumbnailTile: '/12/1546/1172',
                tileTemplate: '/{level}/{row}/{col}',
                title: 'Imagery Hybrid'
            }
        ];
        this.extentConfigs = [
            {
                toolTip: 'Statewide',
                icon: 'm28.531 12.656-.187-.531-1.156-.344-.344-.562-.187-1.437-.719-.312-.094-.344-.375-.312h-20.219v-1.625l-1.656.844 .219-.312-.656.5-1.375.594-.406 13.906 20.719.094h1.719l.313-.531.5-.25.781 .156 1.375-.562.094-.437 1.75-1.312-1.187-1.437h-.25l-.25-.875-.531-.062-.031-.75v-.375l.406-.25.188-.469-.375-.75.844-.844.719-1.25z',
                color: 'white',
                extent: {
                    center: [this.extentCenterPositionLong, this.extentCenterPositionLat],
                    zoom: 8
                },
                extentType: 'static',
                label: 'Statewide Extent'
            },
            {
                toolTip: 'Current Area of Interest',
                icon: 'icon-ui-locate',
                color: 'white',
                extent: () => __awaiter(this, void 0, void 0, function* () { return yield this.getAoi(); }),
                extentType: 'async-func',
                label: 'AOI'
            }
        ];
        this.selectedLayers = [];
        this.layerIdsToBeAdded = [];
        this.childTables = [];
        this.printActive = false;
        this.printOpen = true;
        this.printReady = false;
        this.isIdentifyDialogOpen = false;
        this.identifyDisabledFor = [];
        elementRef.nativeElement.classList.add('flex-display', 'flex-col', 'flex-height-fix', 'height-wrap');
    }
    onActivate(componentRef) {
        this.activeComponent = componentRef;
    }
    activateMeasureTools() {
        if (this.activeComponent) {
            if (this.activeComponent.areaMeasureRef) {
                this.activeComponent.areaMeasureRef.nativeElement.active = true;
            }
            if (this.activeComponent.distanceMeasureRef) {
                this.activeComponent.distanceMeasureRef.nativeElement.active = true;
            }
        }
    }
    get isCwopa() {
        return this.navMenuRef && this.navMenuRef.isCwopaUser;
    }
    get isLoggedIn() {
        return this.navMenuRef && this.navMenuRef.isLoggedIn;
    }
    get isInternal() {
        return this.navMenuRef && this.navMenuRef.isInternal;
    }
    get isAoiSpatialQueryable() {
        return this.aoiLayers && this.aoiLayers.every(l => l.mapcoreProps.geometryTypes && l.mapcoreProps.geometryTypes.includes('polygon')
            || l.graphics && l.graphics.every(g => g.geometry.type === 'polygon'));
    }
    ngAfterViewInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setBasemap();
            this.constructExtent();
            this.setupBasemapSwitcher();
            this.importExternalMap.nativeElement.addEventListener('done', _ => this.closeImportExternalMapWinodw());
            window.addEventListener('addingMapcoreLayersToMap', (event) => { this.addingMapcoreLayersToMap(event); });
            this.layerFilter.nativeElement.addEventListener('onapply', (event) => {
                this.layerFilterWindow.nativeElement.close();
                this.filterLayer.bind(this);
                this.filterLayer(event);
            });
            this.layerFilter.nativeElement.addEventListener('ondone', (event) => {
                this.layerFilterWindow.nativeElement.close();
            });
            this.layerFilter.nativeElement.addEventListener('onlayerdata', e => {
                let name = e.detail.name;
                if (this.filteringLayer && this.filteringLayer.mapcoreProps) {
                    name = this.filteringLayer.mapcoreProps.name;
                }
                this.layerFilterWindow.nativeElement.windowTitle = `Layer Filter: ${name}`;
            });
            this.layerSpatial.nativeElement.addEventListener('onapply', (e) => {
                if (e.detail.results && e.detail.results.length && e.detail.results.length > 0) {
                    for (const result of [...e.detail.results].reverse()) {
                        let message = '', level;
                        if (result.resultCount > 0) {
                            message = 'Execution successful.Matching Feature Count: ' + result.resultCount.toString();
                            level = this.levelMatchingFeaturesFound;
                        }
                        else {
                            message = 'No matching features found.';
                            level = this.levelNoMatchingFeatures;
                        }
                        const event = { detail: { message, level, isPrivate: false }, composed: true };
                        const applicationMessage = new CustomEvent('applicationMessage', event);
                        window.dispatchEvent(applicationMessage);
                    }
                }
                this.spatialNotification(e.detail.results);
                if (!e.detail.isNewLayer) {
                    this.legendRef.nativeElement.refreshTree(true);
                }
            });
            this.bufferWindow.nativeElement.addEventListener('openChange', open => {
                this.buffer.nativeElement.active = open.detail;
            });
            this.buffer.nativeElement.addEventListener('buffered', (e) => {
                if (e.detail) {
                    this.bufferWindow.nativeElement.close();
                }
            });
            calcite.dropdown();
            this.identifyWindow.nativeElement.addEventListener('status', status => {
                this.isLoading = status.detail === 'loading';
                const nearbyAssetsElement = document.getElementById('nearbyAssetsToggleCheckBox');
                if (nearbyAssetsElement) {
                    nearbyAssetsElement.checked = false;
                }
                this.identifyWindow.nativeElement.enableNearbyMapMode = false;
            });
            this.identifyWindow.nativeElement.addEventListener('featureUpdated', (event) => {
                this.updateIdentifyReportLinks(event.detail);
                this.isIdentifyDialogOpen = event.detail != null;
            });
            this.mapRef.nativeElement.MapService.mapStatus.subscribe(status => {
                this.isLoading = status === 'loading';
                this.changeDectRef.detectChanges();
            });
            this.mapRef.nativeElement.AoiService.spatialQueryStatus.subscribe(status => {
                if (status === 'done') {
                    this.isLoading = false;
                }
                else if (status === 'error') {
                    this.isLoading = false;
                    const message = 'Spatial query failed';
                    const level = this.levelError;
                    const event = { detail: { message, level, isPrivate: false }, composed: true };
                    const applicationMessage = new CustomEvent('applicationMessage', event);
                    window.dispatchEvent(applicationMessage);
                }
                else {
                    this.isLoading = true;
                }
                this.changeDectRef.detectChanges();
            });
            this.mapRef.nativeElement.UserSettingsService.userSettingsChange.subscribe(e => {
                if (e.settingName === 'userSettings') {
                    this.userSettingsChange(e.value);
                }
            });
            this.print.nativeElement.addEventListener('onoutputloaded', e => {
                if (!this.printOpen) {
                    this.printReady = true;
                }
            });
            this.exportMapWindowRef.nativeElement.addEventListener('openChange', open => {
                this.exportMapRef.nativeElement.active = open.detail;
            });
            this.exportMapRef.nativeElement.addEventListener('onclose', open => {
                this.exportMapWindowRef.nativeElement.close();
            });
            this.dataTable.nativeElement.addEventListener('closeTab', closedLayerId => {
                const index = this.dataTableArr.findIndex(x => x.layerId === closedLayerId.detail);
                if (index > -1) {
                    this.dataTableArr.splice(index, 1);
                }
                if (!this.dataTableArr.length) {
                    this.dataTable.nativeElement.opened = false;
                }
            });
            this.dataTable.nativeElement.addEventListener('ondraw', () => {
                this.disableIdentify({ key: 'dataTable', disable: true });
            });
            this.dataTable.nativeElement.addEventListener('ondrawcomplete', () => {
                this.disableIdentify({ key: 'dataTable', disable: false });
            });
            this.shareMap.nativeElement.addEventListener('closeShareMap', open => {
                this.shareMapWindow.nativeElement.close();
            });
            this.shareMap.nativeElement.addEventListener('openSaveMap', map => {
                this.saveMapWindow.nativeElement.open();
            });
            this.unshareMap.nativeElement.addEventListener('closeUnshareMap', open => {
                this.unshareMapWindow.nativeElement.close();
            });
            this.imageWindow.nativeElement.addEventListener('openChange', open => {
                if (!open.detail) {
                    this.imageGallery.nativeElement.imageSources = null;
                    this.imageGallery.nativeElement.videoSource = null;
                }
            });
            this.mapRef.nativeElement.EsriInterceptor.esriError.subscribe(error => {
                if (error && error.details && error.details.raw) {
                    const rawMessage = error.details.raw;
                    if (typeof rawMessage === 'string') {
                        this.esriErrorMessage = rawMessage.includes('Permission') ?
                            'You do not have the permission to see the data' :
                            rawMessage.slice(0, rawMessage.indexOf('\n'));
                    }
                    else if (rawMessage.message) {
                        this.esriErrorMessage = rawMessage.message;
                    }
                }
                if (this.esriErrorMessage) {
                    this.esriErrorWindow.nativeElement.open();
                    this.changeDectRef.detectChanges();
                }
            });
            this.esriErrorWindow.nativeElement.addEventListener('openChange', open => {
                if (!open || !open.detail) {
                    this.navMenuRef.resetMap();
                    this.esriErrorMessage = '';
                }
            });
            this.mapRef.nativeElement.AoiService.openStreetViewEvent.subscribe((e) => __awaiter(this, void 0, void 0, function* () {
                this.openSV.next(e);
            }));
        });
    }
    addingMapcoreLayersToMap(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (event) {
                this.selectedLayers = yield Promise.all(event.detail.map((l) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        let filterType = 'filter';
                        this.aoiLayers = this.mapRef.nativeElement.LayerService.getAoiLayers();
                        if (this.aoiLayers.length > 0) {
                            l.aoiQuery = yield this.mapRef.nativeElement.AoiService.generateFilterQuery({ parentId: l.id });
                            if (l.aoiQuery.field || l.aoiQuery.subqueries) {
                                filterType = 'aoi';
                            }
                            else if (this.isAoiSpatialQueryable) {
                                filterType = 'spatialAoi';
                            }
                        }
                        return Object.assign({}, l, { filterType });
                    }
                    catch (error) {
                        console.error(error);
                    }
                })));
                this.filterLayerOptionsWindow.nativeElement.open();
                this.layerFilter.nativeElement.layerId = null;
            }
        });
    }
    onLogIn(loggedIn) {
        if (loggedIn) {
            this.changeDectRef.detectChanges();
        }
        else {
            this.identifyWindow.nativeElement.showIdentify = false;
        }
    }
    closeMinMax() {
        this.minMaxScaleWindow.nativeElement.close();
    }
    setFilters() {
        return __awaiter(this, void 0, void 0, function* () {
            this.layerFilter.nativeElement.layerId = null;
            this.filterLayerOptionsWindow.nativeElement.close();
            const addLayers = this.selectedLayers.filter(l => ['showAll', 'aoi', 'spatialAoi'].includes(l.filterType));
            if (addLayers.length) {
                yield this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap(addLayers.map(layer => {
                    if (layer.filterType === 'showAll' || layer.filterType === 'spatialAoi') {
                        return { id: layer.id };
                    }
                    else if (layer.filterType === 'aoi') {
                        return { id: layer.id, query: layer.aoiQuery };
                    }
                }));
            }
            this.applyDefaultsLayers(this.selectedLayers.filter(l => l.filterType === 'defaults'));
            yield this.applySpatialQueryLayers(this.selectedLayers.filter(l => l.filterType === 'spatialAoi'));
            this.selectedLayers = this.selectedLayers.filter(l => l.filterType === 'filter');
            this.layerIdsToBeAdded = this.selectedLayers.map(l => l.id);
            this.filterLayer(null);
        });
    }
    applySpatialQueryLayers(layers) {
        return __awaiter(this, void 0, void 0, function* () {
            if (layers.length === 0) {
                return;
            }
            yield this.mapRef.nativeElement.AoiService.filterLayers(layers.map(layer => layer.id));
        });
    }
    addLayers(layers) {
        return __awaiter(this, void 0, void 0, function* () {
            const layerAddPromises = [];
            for (const layer of layers) {
                layerAddPromises.push(this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([{ id: layer.id }], null).then(l => {
                    const addedLayer = l[0];
                    if (addedLayer.mapcoreProps.query && addedLayer.mapcoreProps.query.subqueries && addedLayer.mapcoreProps.query.subqueries.length && addedLayer.mapcoreProps.query.subqueries.length > 0) {
                        addedLayer.mapcoreProps.query.subqueries = addedLayer.mapcoreProps.query.subqueries.filter(x => !(x.field.indexOf('plan_year_no') > -1 && x.value === '{replaceYear}'));
                    }
                    let finalQuery = Object.assign({}, addedLayer.mapcoreProps.query);
                    if (addedLayer.mapcoreProps.parentQuery) {
                        finalQuery = this.mapRef.nativeElement.ToSqlStringService.addFilter(Object.assign({}, addedLayer.mapcoreProps.query), addedLayer.mapcoreProps.parentQuery);
                    }
                    if (!finalQuery) {
                        finalQuery = {};
                    }
                    addedLayer.sublayers.forEach(sublayer => {
                        sublayer.source.dataSource.query = JSON.stringify(finalQuery);
                    });
                }));
            }
            yield Promise.all(layerAddPromises);
        });
    }
    applyDefaultsLayers(layers) {
        return __awaiter(this, void 0, void 0, function* () {
            if (layers && layers.length) {
                yield this.addLayers(layers);
                const searchCriteria = [];
                const districts = this.defaults.filter(d => d.startsWith('district'));
                const counties = this.defaults.filter(d => d.startsWith('county'));
                if (districts || counties) {
                    if (!counties.length && districts.length) {
                        // Use districts
                        searchCriteria.push({
                            type: 'district',
                            districtNumbers: districts.map(county => county.replace('district-', ''))
                        });
                    }
                    else if (counties.length) {
                        // Use counties
                        searchCriteria.push({
                            type: 'county',
                            countyCodes: counties.map(county => county.replace('county-', ''))
                        });
                    }
                    this.mapRef.nativeElement.AoiService.setSearchCriterias(searchCriteria);
                    yield this.mapRef.nativeElement.AoiService.filterLayers(layers.map(layer => layer.id));
                }
            }
        });
    }
    filterLayer(event) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (event) {
                    if (event.detail && event.detail.esriLayer) {
                        return;
                    }
                    if (event.detail && event.detail.data) {
                        const layerId = event.detail.id;
                        if (this.layerIdsToBeAdded.indexOf(layerId) >= 0) {
                            const layerSettings = {
                                id: layerId,
                                query: event.detail.data.query,
                                joinColumns: event.detail.data.joinColumns,
                                childColumns: event.detail.data.childColumns,
                                exportJoinFilterParams: event.detail.data.exportJoinFilterParams,
                                parentQuery: event.detail.data.parentQuery,
                                geometryString: event.detail.data.geometryString
                            };
                            this.layerFilter.nativeElement.layerId = null; // Force a reset of the layerId
                            yield this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([layerSettings]);
                            const index = this.layerIdsToBeAdded.indexOf(layerId);
                            if (index !== -1) {
                                this.layerIdsToBeAdded.splice(index, 1);
                            }
                            const esriLayer = this.getEsriLayer(layerId);
                            if (event.detail.data.geometryString && esriLayer.mapcoreProps.spatialQueryParams === undefined) {
                                this.layerSpatial.nativeElement.getSpatialQueryService.applyGeographicFilter(esriLayer, event.detail.data.geometryString);
                            }
                        }
                    }
                }
                if (this.selectedLayers.length > 0) {
                    const nextLayer = this.selectedLayers.shift();
                    this.layerFilter.nativeElement.layerId = null; // Force a reset of the layerId
                    this.layerFilter.nativeElement.layerId = nextLayer.id;
                    this.layerFilterWindow.nativeElement.open();
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    getEsriLayer(layerId) {
        return this.mapRef.nativeElement.map.layers.items.find(layer => layer.mapcoreProps && layer.mapcoreProps.parentId === layerId);
    }
    closeFilterLayerOptionsWindow() {
        this.filterLayerOptionsWindow.nativeElement.close();
    }
    constructExtent() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.extentRef.nativeElement.ready;
            for (const extentConfig of this.extentConfigs) {
                this.extentRef.nativeElement.addExtentConfiguration(extentConfig);
            }
        });
    }
    setBasemap() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.mapRef.nativeElement.ready;
            yield this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
        });
    }
    setupBasemapSwitcher() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.basemapSwitcherRef.nativeElement.ready;
            this.basemapSwitcherRef.nativeElement.addBasemaps(this.basemapList, this.basemapConfigs);
        });
    }
    onOptionSelect(event) {
        return __awaiter(this, void 0, void 0, function* () {
            let target = event.detail.target;
            while (target.tagName.toLowerCase() !== 'button' && target.tagName.toLowerCase() !== 'nav') {
                target = target.parentElement;
            }
            if (target.tagName.toLowerCase() === 'nav') {
                return;
            }
            const layerId = event.detail.layerId;
            const esriLayer = this.getLayerByUniqueId(layerId);
            const exportLayerRef = this.exportLayer.nativeElement.getComponentReference();
            const layer = this.mapRef.nativeElement.map.findLayerById(event.detail.layerId);
            const buttonClass = target.className
                .replace('dropdown-link', '')
                .replace('spatial', '')
                .replace('icon-ui-filter', '')
                .replace('icon-ui-close', '')
                .replace('btn btn-transparent', '')
                .replace('icon-ui-blue', '')
                .trim().toLowerCase();
            switch (buttonClass) {
                case 'save-option':
                    this.saveLayerTool.nativeElement.layerId = layerId;
                    this.saveLayerWindow.nativeElement.open();
                    break;
                case 'share-option':
                    //communicate to nav-menu to open sharelayer
                    this.openShareLayer.next(layer.mapcoreProps.idFromSavedLayer ? layer.mapcoreProps.idFromSavedLayer : layer.mapcoreProps.parentId);
                    break;
                case 'copy-option':
                    this.mapRef.nativeElement.LayerService.copyEsriLayer(esriLayer);
                    break;
                case 'export-excel-option':
                    this.onSelectExportExcel(esriLayer, exportLayerRef);
                    break;
                case 'export-shapefile-option':
                    this.onSelectShapefile(esriLayer, exportLayerRef);
                    break;
                case 'filter-option':
                    this.filteringLayer = esriLayer;
                    this.layerFilter.nativeElement.layerId = null; // Force a reset of the layerId
                    this.layerFilter.nativeElement.layerId = layerId;
                    this.layerFilterWindow.nativeElement.open();
                    break;
                case 'data-dictionary-option':
                    this.onSelectDataDictionary(esriLayer);
                    break;
                case 'data-table-option':
                    this.openDataTable(esriLayer);
                    break;
                case 'min-max-option':
                    this.minMaxScaleWindow.nativeElement.open();
                    this.minMaxScale.nativeElement.uniqueLayerId = esriLayer.id;
                    break;
                case 'labels-option':
                    this.layerLabelsWindow.nativeElement.open();
                    this.layerLabels.nativeElement.uniqueLayerId = esriLayer.id;
                    break;
                case 'delete-option':
                    this.onSelectDelete(esriLayer, layerId);
                    break;
                case 'spatial-query-option':
                    this.layerSpatialQueryWindow.nativeElement.open();
                    this.layerSpatial.nativeElement.primaryLayers = [esriLayer].reverse();
                    this.layerSpatial.nativeElement.joinedLayers = this.mapLayers.filter(l => l.id !== esriLayer.id).filter(l => l.title !== 'Identify').reverse();
                    this.layerSpatial.nativeElement.reset();
                    break;
                case 'renew-spatial-query-option':
                    this.onSelectRenewSpatialQuery(esriLayer);
                    break;
                case 'buffer-layer-option':
                    this.buffer.nativeElement.layer = esriLayer;
                    this.buffer.nativeElement.mapLayers = this.mapLayers.map((l) => {
                        return {
                            id: l.id,
                            name: l.mapcoreProps.name
                        };
                    });
                    this.buffer.nativeElement.mapView = this.mapRef.nativeElement.mapView;
                    this.bufferWindow.nativeElement.windowTitle = 'Buffer Layer';
                    this.bufferWindow.nativeElement.open();
                    break;
                case 'zoom-option':
                    const layerZoomOption = 18;
                    this.mapRef.nativeElement.zoomToLayer(layerId, layerZoomOption);
                    break;
                case 'theme-editor-option':
                    this.themeEditor.nativeElement.layerId = layerId;
                    this.themeEditorWindow.nativeElement.open();
                    break;
                case 'details':
                    target.dispatchEvent(new CustomEvent('opendetails', { bubbles: true, cancelable: true }));
                    break;
                default:
                    break;
            }
            this.dropdownToggle(event.target, event, true);
        });
    }
    onSelectExportExcel(esriLayer, exportLayerRef) {
        exportLayerRef.layerId = esriLayer.mapcoreProps.parentId;
        if (esriLayer.mapcoreProps.isExternal) {
            this.exportExcelParams = { layerId: esriLayer.mapcoreProps.parentId, query: esriLayer.mapcoreProps.query };
        }
        else {
            let layerColumns = esriLayer.mapcoreProps.columns, fieldNames = [];
            if (layerColumns) {
                layerColumns = layerColumns.sort((a, b) => {
                    if (a.databaseColumnOrder > b.databaseColumnOrder) {
                        return 1;
                    }
                    else if (a.databaseColumnOrder < b.databaseColumnOrder) {
                        return -1;
                    }
                    return 0;
                });
                fieldNames = layerColumns.map(x => x.name);
            }
            this.exportExcelParams = { layerId: esriLayer.mapcoreProps.parentId, query: esriLayer.mapcoreProps.query, fieldNames };
        }
        this.mapRef.nativeElement.LayerService.getLayerChildTables(esriLayer.mapcoreProps.parentId).then(childTables => {
            if (childTables && childTables.length > 0) {
                this.childTables = childTables.map(t => {
                    return Object.assign({}, t, { checked: true });
                });
                document.getElementById('exportLayerLegend').innerHTML = esriLayer.mapcoreProps.name;
                document.getElementById('exportLayerFilter').open();
            }
            else {
                exportLayerRef.ExportService.exportToExcelAndOpenUrl(this.exportExcelParams);
            }
        });
    }
    onSelectShapefile(esriLayer, exportLayerRef) {
        return __awaiter(this, void 0, void 0, function* () {
            exportLayerRef.layerId = esriLayer.mapcoreProps.parentId;
            const props = esriLayer.mapcoreProps;
            const rootQuery = { operator: 'AND', subqueries: [] };
            if (props.parentQuery) {
                rootQuery.subqueries.push(props.parentQuery);
            }
            if (props.query) {
                rootQuery.subqueries.push(props.query);
            }
            let geometries = null;
            if (esriLayer && esriLayer.type && esriLayer.type.toLowerCase() === 'graphics') {
                geometries = yield this.mapRef.nativeElement.LayerService.getLayerGeometrySingleType(esriLayer);
            }
            const exportShapeFileParams = {
                name: props.name,
                columns: props.columns,
                tables: props.tables,
                query: rootQuery,
                geometries: geometries ? geometries.map(x => x.toJSON()) : null
            };
            exportLayerRef.ExportService.exportToShapeFileAndOpenUrl(exportShapeFileParams);
        });
    }
    onSelectDataDictionary(esriLayer) {
        let dataDictionaryUrl = environmentOm.internalURLBase + '/DataDictionary/';
        if (esriLayer.mapcoreProps.metaTableId) {
            dataDictionaryUrl += `#/home/tableView/${esriLayer.mapcoreProps.metaTableId}`;
        }
        window.open(dataDictionaryUrl);
    }
    onSelectDelete(esriLayer, layerId) {
        const parentLayer = esriLayer.parent;
        if (parentLayer && parentLayer.type === 'group') {
            parentLayer.remove(esriLayer);
            if (parentLayer.layers.length === 0) {
                this.mapRef.nativeElement.map.remove(parentLayer);
            }
        }
        else {
            this.mapRef.nativeElement.map.remove(esriLayer);
        }
        if (this.dataTable && this.dataTable.nativeElement.opened) {
            this.dataTable.nativeElement.close(layerId);
        }
    }
    onSelectRenewSpatialQuery(esriLayer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (esriLayer.mapcoreProps.spatialQueryParams !== undefined) {
                const params = esriLayer.mapcoreProps.spatialQueryParams;
                const results = yield this.mapRef.nativeElement.SpatialQueryService.renewQuery(params, esriLayer.id);
                this.spatialNotification(results);
            }
        });
    }
    groupOptionSelected(event) {
        const target = event.detail.target;
        const buttonClass = target.className
            .replace('dropdown-link', '')
            .replace('spatial', '')
            .replace('icon-ui-filter', '')
            .replace('icon-ui-close', '')
            .replace('btn btn-transparent', '')
            .trim().toLowerCase();
        if (buttonClass === 'delete-option') {
            this.legendRef.nativeElement.removeGroup(event.detail.groupLayerId);
        }
    }
    exportLayerWithChildTables() {
        return __awaiter(this, void 0, void 0, function* () {
            const exportLayerRef = this.exportLayer.nativeElement.getComponentReference();
            this.exportExcelParams.childTableIds = this.childTables.filter(t => t.checked).map(t => t.tableId);
            this.exportExcelParams.includeLayerChildren = true;
            this.isLoading = true;
            document.getElementById('exportLayerFilter').close();
            try {
                yield exportLayerRef.ExportService.exportToExcelAndOpenUrl(this.exportExcelParams);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.isLoading = false;
            }
        });
    }
    closeExportLayerFilterWindow() {
        document.getElementById('exportLayerFilter').close();
    }
    optionsAttached(event) {
        if (event.detail.target.parentElement.classList.contains('item')) {
            // Filter option buttons here
            // Setup dropdown menu click event
            // Ignore tslint error because need to get scope here since inside function will be different scope
            const compScope = this; // tslint:disable-line
            event.detail.target.getElementsByClassName('layer-options-button')[0].addEventListener('click', function (clickEvent) { compScope.dropdownToggle(this, clickEvent); });
            const layer = this.mapRef.nativeElement.map.findLayerById(event.detail.layerId);
            this.removeLayerClasses(layer, event);
            const renewOption = event.detail.target.getElementsByClassName('renew-spatial-query-option');
            if (renewOption.length) {
                if (!layer.mapcoreProps || !layer.mapcoreProps.spatialQueryParams) {
                    renewOption[0].style.display = 'none';
                }
                else {
                    renewOption[0].style.display = null;
                }
            }
        }
    }
    removeLayerClasses(layer, event) {
        let removeClasses = [];
        switch (layer.type) {
            case 'graphics':
                removeClasses = ['copy-option', 'data-dictionary-option', 'data-table-option',
                    'export-excel-option', 'filter-option', 'labels-option',
                    'spatial-query-option', 'theme-editor-option', 'details'];
                if (layer.graphicLayer && layer.graphicLayer === 'text') {
                    removeClasses.push('export-shapefile-option');
                }
                else if (layer.graphics && layer.graphics.items.length && layer.graphics.items[0].attributes && layer.graphics.items[0].attributes.type === 'callout') {
                    removeClasses.push('export-shapefile-option'); // Callouts text does not export. For now hide
                }
                break;
            case 'feature':
                removeClasses = ['copy-option', 'data-dictionary-option', 'export-shapefile-option',
                    'export-excel-option', 'labels-option', 'share-option',
                    'spatial-query-option', 'theme-editor-option'];
                break;
            case 'map-image':
                break;
            default:
                break;
        }
        const renewOption = event.detail.target.getElementsByClassName('renew-spatial-query-option');
        if (renewOption.length) {
            if (!layer.mapcoreProps || !layer.mapcoreProps.spatialQueryParams) {
                renewOption[0].style.display = 'none';
            }
            else {
                renewOption[0].style.display = null;
            }
        }
        for (const cls of removeClasses) {
            const els = event.detail.target.getElementsByClassName(cls);
            if (els && els.length) {
                Array.from(els).forEach(el => el.remove());
            }
        }
    }
    spatialNotification(results) {
        if (results && results.length && results.length > 0) {
            for (const result of results.reverse()) {
                let message = '', level;
                if (result.resultCount > 0) {
                    message = 'Execution successful.Matching Feature Count: ' + String(result.resultCount);
                    level = this.levelMatchingFeaturesFound;
                }
                else {
                    message = 'No matching features found.';
                    level = this.levelNoMatchingFeatures;
                }
                const applicationMessage = new CustomEvent('applicationMessage', { detail: { message, level, isPrivate: false }, composed: true });
                window.dispatchEvent(applicationMessage);
            }
        }
    }
    dropdownToggle(target, event, forceClose) {
        if (!forceClose) {
            const allDrops = target.closest('.angular-tree-component').getElementsByClassName('dropdown-menu');
            for (const item of Array.from(allDrops)) {
                const layerGear = item.parentElement.getElementsByClassName('layer-options-button')[0];
                layerGear.classList.remove('dropped');
                item.style.display = '';
            }
        }
        const gear = target.parentElement.getElementsByClassName('layer-options-button')[0];
        const drop = target.parentElement.getElementsByClassName('dropdown-menu')[0];
        if (drop) {
            const currentDisplay = drop.style.display;
            drop.style.display = currentDisplay === 'block' || forceClose ? '' : 'block';
            const gearPosition = gear.getBoundingClientRect();
            const pixelAdjustment = 25;
            drop.style.left = `${gearPosition.left + pixelAdjustment}px`;
            drop.style.top = `${gearPosition.top}px`;
            const dropPosition = drop.getBoundingClientRect();
            if (dropPosition.bottom > window.innerHeight) {
                const difference = dropPosition.bottom - window.innerHeight;
                drop.style.top = `${gearPosition.top - difference}px`;
            }
            if (forceClose) {
                gear.classList.remove('dropped');
            }
            else {
                gear.classList.add('dropped');
            }
        }
        this.setupClickEventListener(target, event, drop);
    }
    setupClickEventListener(target, event, drop) {
        const restClickListener = (e) => {
            if (!e.target.classList.contains('dropdown-link')) {
                this.dropdownToggle(target, e, true);
                window.removeEventListener('click', restClickListener);
            }
        };
        event.stopPropagation();
        if (drop.style.display === 'block') {
            window.addEventListener('click', restClickListener);
        }
        else {
            window.removeEventListener('click', restClickListener);
        }
    }
    getLayerByUniqueId(layerId) {
        return this.mapLayers.filter(l => l.id === layerId)[0];
    }
    get mapLayers() {
        const mapLayers = [];
        for (const layer of this.mapRef.nativeElement.map.layers.toArray()) {
            if (layer.type === 'group') {
                for (const sub of layer.layers.toArray()) {
                    mapLayers.push(sub);
                }
            }
            else {
                mapLayers.push(layer);
            }
        }
        return mapLayers;
    }
    openSaveMapWindow() {
        this.saveMapWindow.nativeElement.open();
    }
    openIdentifyToggleWindow() {
        this.identifyToggleWindow.nativeElement.open();
    }
    openImportExternalMapWindow() {
        this.importExternalMapWindow.nativeElement.open();
    }
    openSpatialQueryWindow() {
        this.layerSpatialQueryWindow.nativeElement.open();
        this.layerSpatial.nativeElement.primaryLayers = [];
        this.layerSpatial.nativeElement.joinedLayers = [];
        this.layerSpatial.nativeElement.reset();
    }
    closeImportExternalMapWinodw() {
        this.importExternalMapWindow.nativeElement.close();
    }
    openMapPrintWindow() {
        this.printStatus(true);
    }
    closePrint() {
        this.printStatus(false);
    }
    openFeatureBufferWindow(e) {
        this.buffer.nativeElement.geometry = e.detail;
        this.bufferWindow.nativeElement.windowTitle = 'Buffer Feature';
        this.bufferWindow.nativeElement.open();
    }
    updateIdentifyReportLinks(feature) {
        if (!feature || !feature.sourceLayer || (!feature.sourceLayer.mapcoreProps && !feature.sourceLayer.parent.mapcoreProps)) {
            return;
        }
        const featureTableNames = feature.sourceLayer.mapcoreProps ? feature.sourceLayer.mapcoreProps.tableNames : feature.sourceLayer.parent.mapcoreProps.tableNames;
        let reportType = null;
        Object.entries(this.reportHelper.tableNames).forEach(tableNameArr => {
            for (const tableName of tableNameArr[1]) {
                if (featureTableNames.includes(tableName)) {
                    reportType = tableNameArr[0];
                    break;
                }
            }
        });
        // Remove previous buttons
        if (this.identifyWindow.nativeElement.firstChild) {
            this.identifyWindow.nativeElement.firstChild.remove();
        }
        switch (reportType) {
            case 'mpms':
                const projectId = JSON.stringify({ projectId: feature.attributes.filter(x => x.columnName === 'PROJECT_ID')[0].value.toString() });
                this.createIdentifyReportButtons([{ reportName: 'projectStatusReport', displayName: 'Project Status Report' }, { reportName: 'projectDetailReport', displayName: 'Project Detail Report' }], projectId);
                break;
            case 'bridges':
                const bridgeId = JSON.stringify({ bridgeId: feature.attributes.filter(x => x.columnName === 'BRKEY')[0].value.toString() });
                const reportNames = [];
                reportNames.push({ reportName: 'basicBridgeReport', displayName: 'Basic Bridge Report' });
                if (this.isCwopa) {
                    reportNames.push({ reportName: 'detailBridgeReport', displayName: 'Detail Bridge Report' });
                }
                this.createIdentifyReportButtons(reportNames, bridgeId);
                break;
            case 'hop':
                // Disabling report for now, is not functioning in Prod and SQL query needs updated
                break;
            default:
                break;
        }
    }
    createIdentifyReportButtons(buttons, featureData) {
        const div = document.createElement('div');
        div.setAttribute('slot', 'report-links');
        for (const button of buttons) {
            const newButton = document.createElement('button');
            newButton.classList.add('btn', 'btn-clear');
            newButton.innerText = button.displayName;
            div.appendChild(newButton);
            newButton.addEventListener('click', () => {
                this.launchIdentifyReport(button.reportName, JSON.parse(featureData));
            });
        }
        this.identifyWindow.nativeElement.appendChild(div);
    }
    launchIdentifyReport(reportName, data) {
        this.reportLauncher.generateReport(reportName, data);
    }
    getAoi() {
        return __awaiter(this, void 0, void 0, function* () {
            const aoiLayer = this.mapRef.nativeElement.LayerService.getAoiLayers();
            if (aoiLayer.length) {
                const aoiExtent = yield this.mapRef.nativeElement.LayerService.getLayerExtent(aoiLayer[0]);
                return aoiExtent;
            }
        });
    }
    onLargerImageRequest(event) {
        if (!event || !event.detail || !Array.isArray(event.detail)) {
            return;
        }
        const images = event.detail;
        this.imageWindow.nativeElement.open();
        this.imageGallery.nativeElement.imageSources = images;
    }
    onLargerVideoRequest(event) {
        if (!event || !event.detail) {
            return;
        }
        const video = event.detail;
        this.imageWindow.nativeElement.open();
        this.imageGallery.nativeElement.videoSource = video;
    }
    onSymbolChange(event) {
        if (!event.detail.symbolIsColorRamp) {
            this.symbolEditorWindow.nativeElement.open();
            this.symbolEditor.nativeElement.uniqueLayerId = event.detail.uniqueLayerId;
        }
        else {
            this.themeEditorWindow.nativeElement.open();
            this.themeEditor.nativeElement.layerId = event.detail.uniqueLayerId;
        }
    }
    printStatus(active) {
        this.printActive = active;
        this.print.nativeElement.active = active;
        if (active) {
            this.printOpen = true;
            this.printReady = false;
        }
        this.disableIdentify({ key: 'print', disable: active });
    }
    disableIdentify(value) {
        if (value.disable) {
            this.identifyWindow.nativeElement.deactivate();
            this.identifyDisabledFor.push(value.key);
        }
        else {
            this.identifyDisabledFor.splice(this.identifyDisabledFor.indexOf(value.key), 1);
            if (this.identifyDisabledFor.length < 1) {
                this.identifyWindow.nativeElement.activate();
            }
        }
    }
    toggleCollapsePrintArea() {
        this.printOpen = !this.printOpen;
        if (!this.printOpen) {
            this.identifyWindow.nativeElement.activate();
        }
        else {
            this.identifyWindow.nativeElement.deactivate();
            this.printReady = false;
        }
    }
    onResetPress() {
        this.identifyWindow.nativeElement.showIdentify = false;
        this.extentRef.nativeElement.executeExtentChange(this.extentConfigs[0]);
        this.printStatus(false);
        this.saveLayerWindow.nativeElement.close();
        this.saveMapWindow.nativeElement.close();
        this.shareMapWindow.nativeElement.close();
        this.unshareMapWindow.nativeElement.close();
        this.layerFilterWindow.nativeElement.close();
        this.minMaxScaleWindow.nativeElement.close();
        this.layerLabelsWindow.nativeElement.close();
        this.layerSpatialQueryWindow.nativeElement.close();
        this.themeEditorWindow.nativeElement.close();
        this.symbolEditorWindow.nativeElement.close();
        this.importExternalMapWindow.nativeElement.close();
        this.bufferWindow.nativeElement.close();
        this.identifyToggleWindow.nativeElement.close();
        this.exportMapWindowRef.nativeElement.close();
        this.dataTable.nativeElement.opened = false;
        this.dataTable.nativeElement.closeAll();
    }
    onResetConfirm() {
        this.dataTable.nativeElement.closeAll();
    }
    userSettingsChange(e) {
        const districts = e.districts.value ? e.districts.value : e.districts;
        const counties = e.counties.value ? e.counties.value : e.counties;
        this.defaults = [...districts, ...counties];
    }
    setStreetViewDefaultLocation(e) {
        this.lastIdentifiedPointCRS = e.detail;
    }
    openMergeMap() {
        this.navMenuRef.mergeMap();
    }
    openExportMap() {
        this.exportMapWindowRef.nativeElement.open();
    }
    openVideolog(e) {
        this.openVL.next(e.detail);
    }
    openStreetView(e) {
        this.openSV.next(e.detail);
    }
    openAllDataTables() {
        //for each applicable layer in maplayers, open its data-table
        let i = 1;
        const openDelay = 20;
        for (const layer of this.mapLayers) {
            if (layer.type === 'feature' || layer.type === 'map-image') {
                setTimeout(() => {
                    this.openDataTable(layer);
                }, i * openDelay);
            }
            i++;
        }
    }
    openDataTable(layer) {
        if (!this.dataTableLayerUniqueId) {
            this.layerFilter.nativeElement.addEventListener('onapply', (data) => {
                if (data.detail && data.detail.esriLayer && data.detail.esriLayer.id === this.dataTableLayerUniqueId && this.dataTable.nativeElement.mapcoreProps) {
                    this.dataTable.nativeElement.mapcoreProps.query = data.detail.esriLayer.mapcoreProps.query;
                    this.dataTable.nativeElement.mapcoreProps = Object.assign({}, data.detail.esriLayer.mapcoreProps);
                }
            });
        }
        this.dataTableLayerUniqueId = layer.id;
        const mcProps = Object.assign({}, layer.mapcoreProps);
        mcProps.esriLayerId = layer.id;
        mcProps.isExternal = layer.type === 'feature';
        if (this.dataTableArr.findIndex(x => x.layerId === this.dataTableLayerUniqueId) === -1) {
            this.dataTableArr.push({ name: mcProps.name, layerId: this.dataTableLayerUniqueId });
            mcProps.dataTableArr = this.dataTableArr;
        }
        this.dataTable.nativeElement.mapcoreProps = mcProps;
        this.dataTable.nativeElement.opened = true;
    }
    openShareMap(maps) {
        this.shareMapWindow.nativeElement.open();
        if (maps !== undefined) {
            this.shareMap.nativeElement.map = maps;
        }
        else {
            this.shareMap.nativeElement.map = this.mapRef.nativeElement.mapView.mapcoreViewProps;
        }
    }
    onImportShapefileDrop(event) {
        this.isLoading = true;
    }
    onImportShapefileDone(event) {
        this.isLoading = false;
    }
    toggleNearbySearch(event) {
        const nearbyToggle = event.target;
        this.identifyWindow.nativeElement.enableNearbyMapMode = nearbyToggle.checked;
    }
    showNearbyAssetsBtn() {
        if (this.navMenuRef && this.navMenuRef.userPermissions) {
            return this.navMenuRef.userPermissions.includes('View Nearby Data');
        }
        else {
            return false;
        }
    }
}
